<template>
    <div class="mb-3">
        <div class="custom-div-outer">
        <b-row class="custom-outer-filter">
            <b-col md="4">
                    <b-form-group label="Hub Name" :label-cols="3">
                        <div id='container' style="width: 230px;">
                            <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    
                            :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox"
                            ></ejs-multiselect>
                        </div>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Selecte From Date:"  :label-cols="6" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectFromDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Selecte To Date:"  :label-cols="5" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectToDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mb-5 text-right">
                    <b-button variant="primary" @click="getFilterList()"> Search </b-button>&nbsp;
                    <b-button variant="danger" @click="clearFilter(activeTab)"> Clear </b-button>&nbsp;
                </b-col>
            </b-row>
        </div> 

        <div id="listloader" v-if="loader">
            <div class="listloader"></div>
        </div>

        <b-row>
            <b-col md="12">
                <div>
                    <ul class="nav nav-tabs nav-justified mb-3">
                        <li class="nav-item">
                            <a @click="activeTab = 0" class="nav-link text-center custom-link" :class="{'active': isActiveTab(0)}">
                                <div>Pending Requests - {{ All_count_List['Approval Pending'] }}</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="activeTab = 1" class="nav-link text-center custom-link" :class="{'active': isActiveTab(1)}">
                                <div>Approved Requests - {{ All_count_List['Approved'] }}</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="activeTab = 2" class="nav-link text-center custom-link" :class="{'active': isActiveTab(2)}">
                                <div>Rejected Requests - {{ All_count_List['Rejected'] }}</div>
                            </a>
                        </li>
                    </ul>
                </div>                              
            </b-col>
  
            <b-col md="12">
                <div class="tab-panel" v-if="isActiveTab(0)">
                    <b-col sm="12" v-if="pendingRequest.length>0">
                        <input class="selectAllcheckbox ml-2" v-b-tooltip.hover title="Select All" type='checkbox' @click='checkAll()' v-model='isCheckAll' id="allseleted" /> Select All Pending

                        <b-button class="shrek-color" @click="approveALLRequest('checkAll')" v-if="selectrequestid.length">Approve</b-button>
                    </b-col>
                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{pending_count}}</strong>
                    </b-col>

                    <!-- /// table -->

                    <b-table show-empty responsive  :fields="fields" :items="pendingRequest" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="select" slot-scope="row">
                            <div>
                                <input  type="checkbox"  v-bind:value="row.item.requestid" @change="multiselectdesign($event,row.item)"  v-model='selectrequestid' />
                            </div>
                        </template>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel','showApproveButton')">{{ row.item.requestid }}</button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="vehicle_size" slot-scope="row">
                            <div>
                                {{ row.item.vehicle_size }} FT
                            </div>
                        </template>
                        <template slot="volumetric_wt" slot-scope="row">
                            <div>
                                {{ row.item.volumetric_wt }} T
                            </div>
                        </template>
                        <template slot="action" slot-scope="row">
                            <div>
                                <b-button class="shrek-color mt-1" @click="approveALLRequest('table',row.item)" size="sm">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </b-button> &nbsp; 
                                <b-button class="mt-1" variant="danger" @click="rejectedRequest(row.item.requestid)" size="sm">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </b-button>
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                    <!-- pagination -->
                    <paginate v-model="pageNum"
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>
                </div>


                <div class="tab-panel" v-if="isActiveTab(1)">
                    <!-- <button @click="fetchApprovalRequestData(approvepageNum,'approvedAllRequest')" class="cutom-view-all-btn">View All Requests</button> -->

                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{ApprovedRequest_count}}</strong>
                    </b-col>

                    <b-table show-empty responsive  :fields="fieldsApproved" :items="ApprovedRequest" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')">{{ row.item.requestid }}</button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                     <!-- pagination -->
                     <paginate v-model="approvepageNum"
                     :page-count="approvenoofpages"
                     :page-range="10"
                     :margin-pages="2"
                     :click-handler="approveClickCallback"
                     :prev-text="'Prev'"
                     :next-text="'Next'"
                     :container-class="'pagination'"
                     :page-class="'page-item'">
                 </paginate>

    
                </div>


                <div class="tab-panel" v-if="isActiveTab(2)">
                    <!-- <button @click="fetchVehicleRejectedData(rejectpageNum,'AllRequest')" class="cutom-view-all-btn">View All Requests</button> -->

                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{vehicleRejected_count}}</strong>
                    </b-col>

                    <b-table show-empty responsive  :fields="fieldsRejected" :items="vehicleRejected" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                            <template slot="requestid" slot-scope="row">
                                <div>
                                    <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')">{{ row.item.requestid }}</button>
                                </div>
                            </template>
                            <template slot="delivery_locations" slot-scope="row">
                                <div>
                                    <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                                </div>
                            </template>
                            <template slot="lastmodifieddate" slot-scope="row">
                                <div>
                                    {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                                </div>
                            </template>
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>

                      <!-- pagination -->
                      <paginate v-model="rejectpageNum"
                      :page-count="rejectnoofpages"
                      :page-range="10"
                      :margin-pages="2"
                      :click-handler="rejectClickCallback"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination'"
                      :page-class="'page-item'">
                  </paginate>
                </div>
            </b-col>
        </b-row>
        
        
        <!-- plan modal start here -->
        <b-modal :title="'View Plan Screen'" v-model="plandetailsmodal" size="xl" hide-footer modal-class="text-center">
            
            <template slot="default" slot-scope="{ hide }">

                <div id="listloader" v-if="loadermodel">
                    <div class="listloader"></div>
                </div>
        
                <b-col sm="12" class="text-right">
                    <strong>Total Records : </strong><b style="color: red;">{{planScrrenDetails_count}}</b>
                </b-col>
                <b-table show-empty responsive :fields="fieldsPlanScrren" :items="planScrrenDetails" :busy="planisBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </b-table>  
                <div class="text-right" v-if="planScrrenDetails_count && showApproveButton=='showApproveButton'">
                    <b-button class="shrek-color mt-1" @click="approveALLRequest('table',planDetails)" size="sm">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </b-button> &nbsp; 
                    <b-button class="mt-1" variant="danger" @click="rejectedRequest(planDetails.requestid)" size="sm">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </b-button>
                </div> 
                <!-- pagination -->
                <paginate v-model="planviewpageNum"
                        :page-count="planviewnoofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="planViewclickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>             
            </template>
                   
           
            <template slot="modal-footer" slot-scope="{ hide }">
                <b-button size="sm" style="display:none">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <!-- plan modal end here -->  
</div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
// import Swal from 'sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.all';
export default {
  name: 'MyTabs',
  data () {
        return {
            All_count_List: {
                "Approval Pending": 0,
                "Approved": 0,
                "Rejected": 0
            },

            activeTab: 0, // The first tab is active by default //

            loader : false,
            loadermodel : false,
            // search all 
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            selectFromDate : null,
            selectToDate: null,


            // all listing
            fields : [ 
                { key : 'select', label : 'Select', sortable: true},
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'action', label : 'Action', sortable: true},
            ],
            fieldsApproved: [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'lastmodifieddate', label : 'Last Modifed BY & on', sortable: true},
            ],
            fieldsRejected: [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'reason', label : 'Status Remark.', sortable: true},
                { key : 'lastmodifieddate', label : 'Last Modifed BY & on', sortable: true},
            ],
    
            pendingRequest: [],
            pending_count: 0,

            ApprovedRequest: [],
            ApprovedRequest_count: 0,

            vehicleRejected: [],
            vehicleRejected_count: 0,



            // plan model
            plandetailsmodal: false,
            fieldsPlanScrren : [ 
                { key : 'origin', label : 'Planning Origin', sortable: true, sortDirection: "desc"},
                { key : 'planningdate', label : 'Planning Date', sortable: true, sortDirection: "desc"},
                { key : 'load_id', label : 'Load ID' , sortable: true, sortDirection: "desc"},
                { key : 'wh_hub', label : 'WH / HUB', sortable: true, sortDirection: "desc"},
                { key : 'mpscount', label : 'No Of Boxes', sortable: true, sortDirection: "desc"},
                { key : 'parentawb', label : 'Shipping Reference No', sortable: true, sortDirection: "desc"},
                { key : 'userid', label : 'User ID', sortable: true, sortDirection: "desc"},
                { key : 'destinationcompanyname', label : 'Company Name', sortable: true, sortDirection: "desc"},
                { key : 'destinationcity', label : 'Destination City', sortable: true, sortDirection: "desc"},
                { key : 'warehousename', label : 'Warehouse Name / Hub Zone', sortable: true, sortDirection: "desc"},
                { key : 'loadpotype', label : 'Load Po Type', sortable: true, sortDirection: "desc"},
                { key : 'valweight', label : 'shipment Volumetric weight', sortable: true, sortDirection: "desc"},
                { key : 'destinationpincode', label : 'Shipping code', sortable: true, sortDirection: "desc"},
                { key : 'unload_sequence', label : 'unloading sequence', sortable: true, sortDirection: "desc"},
            ],
            planScrrenDetails: [],
            planScrrenDetails_count :0,
            planisBusy:false,
            planDetails:{},
            showApproveButton:'',

            planviewpageNum:1,
            planviewnoofpages:'',


            bordered:true,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,


            ///check all
            isCheckAll:false,
            selectrequestid :[],
            selectapproverequest:[],

            // 1st pagination
            noofpages:'',
            pageNum:1,

            rejectnoofpages:'',
            rejectpageNum:1,

            approvenoofpages:'',
            approvepageNum:1,

            isSearch:false,
        }
    },

    // mounted(){
    //     var userdata = localStorage.getItem("userData");
    //     var userInfo = JSON.parse(userdata);
    //     this.allTabCount();
        
    // },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.pendingTabCount();
        this.isActiveTab(0);
        this.getPendingList(this.pageNum);
        this.showWHlist();
    },
    
    watch: {
        activeTab(newTab, oldTab) {
            this.isCheckAll = false
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.isSearch = false;

            if (newTab === 0) {
                this.pageNum=1;
                this.getPendingList(this.pageNum);
                this.pendingTabCount();
            }
            if (newTab === 1) {
                this.approvepageNum=1;
                this.fetchApprovalRequestData(this.approvepageNum);
                this.pendingTabCount();
            }
            if (newTab === 2) {
                this.rejectpageNum=1;
                this.fetchVehicleRejectedData(this.rejectpageNum);
                this.pendingTabCount();
            }
        },
    },
    methods: {
        // count of all tab
        pendingTabCount() {
            this.loader = true;
            const userdata = localStorage.getItem("userData");
            if (userdata) {
                const userInfo = JSON.parse(userdata);
                const obj = {
                    tab: 2,
                    sysusermasterid: null,
                };

                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAdhocVehicleRequestsCount`, obj)
                    .then(result => {
                        this.loader = false;
                        if (result.body.returnmsg === 'Successful') {
                            this.All_count_List = result.body.returnvalue;
                        } else {
                            this.All_count_List = {
                                "Approval Pending": 0,
                                "Approved": 0,
                                "Rejected": 0
                            };
                        }
                    })
                    .catch((ex) => {
                        this.loader = false;
                        console.log("Error:", ex);
                    });
            }
        },

        isActiveTab(id){
            return this.activeTab === id
        },

        //Pending list 
        clickCallback (pageNum){
            this.isCheckAll = false
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.pageNum = pageNum;
            this.getPendingList(pageNum);
        },

        getPendingList : function (pageNo) {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
            }

            const obj = {
                // sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: null,
                tab: 2,
                pageno: `${pageNo}`,
                hubid: this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Approval Pending"
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.pendingRequest = result.body.returnvalue;
                    this.pending_count = result.body.returnvalue[0].totalcount;
                    this.noofpages=parseInt(this.pending_count)/10;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.noofpages='';
                    this.pendingRequest=[];
                    this.pending_count = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        
        //Approve List
        approveClickCallback(approvepageNum){
            this.fetchApprovalRequestData(approvepageNum);
        },

        fetchApprovalRequestData: function (pageNo,pendingAllReq) {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if (pendingAllReq === 'approvedAllRequest') {
                // userInfo.sysusermasterid = null;
                this.approvepageNum=1;
                this.isSearch = true;
            }
            const obj = {
                // sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: null,
                tab: 2,
                pageno: `${pageNo}`,
                hubid: this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Approved"
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.ApprovedRequest = result.body.returnvalue;
                    this.ApprovedRequest_count = result.body.returnvalue[0].totalcount;
                    this.approvenoofpages=parseInt(this.ApprovedRequest_count)/10;
                    this.approvenoofpages=Math.ceil( this.approvenoofpages);
                } else {
                    this.approvenoofpages='';
                    this.ApprovedRequest = [];
                    this.ApprovedRequest_count = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
       
      
        //Reject FLow 
        rejectClickCallback(rejectpageNum){
            this.fetchVehicleRejectedData(rejectpageNum);
        },

        fetchVehicleRejectedData: function (pageNo,AllRequest) {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;

            if (AllRequest === 'AllRequest') {
                // userInfo.sysusermasterid = null
                this.isSearch = true;
            }

            
            const obj = {
                // sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: null,
                tab: 2,
                pageno: `${pageNo}`,
                hubid: this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Rejected"
            };

            // return false//----
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.vehicleRejected = result.body.returnvalue;
                    this.vehicleRejected_count = result.body.returnvalue[0].totalcount;
                    this.rejectnoofpages=parseInt(this.vehicleRejected_count)/10;
                    this.rejectnoofpages=Math.ceil( this.rejectnoofpages);
                } else {
                    this.rejectnoofpages='';
                    this.vehicleRejected = [];
                    this.vehicleRejected_count = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        // hub list
        showWHlist:function(){
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
                .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                        id: this.WHData[j].hubid,
                        }
                    this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            

            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        getFilterList() {
            this.isSearch = true;
            this.pendingTabCount();
            this.isCheckAll = false
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.pageNum=1;
            this.approvepageNum=1;
            this.rejectpageNum=1;
            if (this.activeTab === 0) {
                this.pendingRequest=[];
                this.pending_count = 0;
                this.getPendingList(this.pageNum)
            }
            if (this.activeTab === 1) {
                this.ApprovedRequest = [];
                    this.ApprovedRequest_count = 0;
                this.fetchApprovalRequestData(this.approvepageNum)
            }
            if (this.activeTab === 2) {
                this.vehicleRejected = [];
                    this.vehicleRejected_count = 0;
                this.fetchVehicleRejectedData(this.rejectpageNum)
            }
        },

        
        clearFilter(active) {
            this.pendingTabCount();
            this.selectToDate = null;
            this.selectFromDate= null;
            this.valueWH= [];
            this.isCheckAll = false
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.pageNum=1;
            this.approvepageNum=1;
            this.rejectpageNum=1;

            if (this.activeTab === active) {
                this.pendingRequest=[];
                this.pending_count = 0;
                this.getPendingList(this.pageNum)
            }
            if (this.activeTab === active) {
                this.ApprovedRequest = [];
                this.ApprovedRequest_count = 0;
                this.fetchApprovalRequestData(this.approvepageNum)
            }
            if (this.activeTab === active) {
                this.vehicleRejected = [];
                this.vehicleRejected_count = 0;
                this.fetchVehicleRejectedData(this.rejectpageNum)
            }
        },


        planViewclickCallback(planviewpageNum){
            this.viewPlanDetails(planviewpageNum,this.planDetails)
        },

        viewPlanDetails(pageno,value,openmodel,showApproveButton) {
            this.loadermodel=true;
            this.planDetails = {};
            this.showApproveButton='';
            this.planDetails = value;
            this.showApproveButton=showApproveButton;
            this.plandetailsmodal = true;
            if (openmodel=='openmodel') {
                pageno=1;
                this.planviewpageNum=1;
            }
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
            
                const obj = {
                    planid: `${this.planDetails.planid}`,
                    // planid:'101',
                    pageno: `${pageno}`,
                };

                // return false
                this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getPlanDetailsForRequest`,obj).then(result => {
                    this.loadermodel=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.planScrrenDetails = result.body.returnvalue;
                        this.planScrrenDetails_count =  result.body.totalcount;
                        this.planviewnoofpages=parseInt(this.planScrrenDetails_count)/10;
                        this.planviewnoofpages=Math.ceil( this.planviewnoofpages);
                    } else {
                        this.planviewnoofpages='';
                        this.planScrrenDetails = [];
                        this.planScrrenDetails_count = 0;
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
            
        },

        downloadCSV(value){
            this.loadermodel=true;
            console.log("value",value)
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            let parent = [];

            parent.push(value.parentawb)

            let obj = {
                parentawb:parent,
                userId: value.userid,
                platform: "web"
            }

            // return false;
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadAllDocAWBWise`,obj)
                .then((result) => {
                    this.loadermodel=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "success",
                            timer: 30000
                        });
                        
                    } else {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            });
                    
                    }
                }).catch((ex) => {
                    console.log('error-----', ex)
                })
        },

        //Pending to Approve flow
        checkAll: function(){

            this.isCheckAll = !this.isCheckAll;
            this.selectrequestid = [];
            this.selectapproverequest = [];

            if(this.isCheckAll){ // Check all

                for (var key in this.pendingRequest) {
                    this.selectapproverequest.push(this.pendingRequest[key])
                    this.selectrequestid.push(this.pendingRequest[key].requestid);
                }
            }
        },

        multiselectdesign(e, value) {
            // Check if the checkbox is checked
            if (e.target.checked) {
                // Add the value to the array if it's not already included
                if (!this.selectapproverequest.includes(value)) {
                    this.selectapproverequest.push(value);
                }

                // If all checkboxes are selected, set isCheckAll to true
                if (this.selectapproverequest.length === this.pendingRequest.length) {
                    this.isCheckAll = true; 
                }
            } else {
                // Remove the value if the checkbox is unchecked
                this.selectapproverequest = this.selectapproverequest.filter(item => item !== value);
                
                // Uncheck the "Select All" option if any checkbox is unchecked
                this.isCheckAll = false;
            }
        },



        approveALLRequest(type, value) {
    let tableRows = '';
    if (type === 'checkAll') {
        this.selectapproverequest.forEach(plan => {
            tableRows += `
                <tr>
                    <td>${plan.origin}</td>
                    <td>${plan.route}</td>
                    <td>${plan.vehicle_size}</td>
                    <td>${plan.createdby}</td>
                </tr>
            `;
        });
    }

    if (type === 'table') {
        this.selectrequestid = [];
        this.selectapproverequest = [];
        this.isCheckAll = false;
        let approvearray = [];
        approvearray.push(value);

        approvearray.forEach(plan => {
            tableRows += `
                <tr>
                    <td>${plan.origin}</td>
                    <td>${plan.route}</td>
                    <td>${plan.vehicle_size}</td>
                    <td>${plan.createdby}</td>
                </tr>
            `;
        });
    }

    Swal.fire({
        title: "<h3>Confirm Approval</h3><hr>",
        html: `
            Please confirm the approval of the below adhoc plans.
            <br/><br/>
            <table border="1" cellpadding="5" cellspacing="0" style="width:100%; text-align: left;">
                <thead>
                <tr>
                    <th>Origin</th>
                    <th>Route</th>
                    <th>Vehicle Size</th>
                    <th>Request By</th>
                </tr>
                </thead>
                <tbody>
                ${tableRows}
                </tbody>
            </table>
            <br/>
            <textarea id="approvalComments" rows="4" style="width: 100%;" placeholder="Add comments for approval..."></textarea>
        `,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        confirmButtonColor: "#00c0ef",
        cancelButtonText: "Close",
        cancelButtonColor: "#F8943F",
        didOpen: () => {
            const textarea = document.getElementById('approvalComments');
            const confirmBtn = Swal.getConfirmButton();
            confirmBtn.disabled = true; // disable initially

            textarea.addEventListener('input', () => {
                confirmBtn.disabled = textarea.value.trim() === '';
            });
        }
    }).then((result) => {
        if (result.isConfirmed) {
            const comments = document.getElementById('approvalComments').value.trim();
            this.loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (this.selectrequestid.length == 0 && type == 'checkAll') {
                this.$fire({
                    text: 'Please Select At Least One Request ID',
                    type: "warning",
                    timer: 30000
                });
                this.loader = false;
                return false;
            }

            const obj = {
                requestids: type == 'checkAll' ? this.selectrequestid : [value.requestid],
                approvedby: userInfo.userfirstname + userInfo.userlastname,
                sysusermasterid: userInfo.sysusermasterid,
                comments: comments,
                delivery_location_without_plan: value.delivery_location_without_plan
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approveAdhocRequests`, obj).then(result => {
                this.loader = false;
                if (result.body.returnmsg == "Successful") {
                    this.$fire({
                        text: "Request Approved Successfully!",
                        type: "success",
                        timer: 300000,
                    });
                    this.selectrequestid = [];
                    this.isCheckAll = false;
                    this.selectapproverequest = [];
                    this.getPendingList(1);
                    this.allTabCount();
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 300000,
                    });
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
                'Cancelled',
                'Your action has been cancelled',
                'error'
            );
        }
        return false;
    });
},

        rejectedRequest(value) {
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.isCheckAll = false;

            Swal.fire({
                title: "<h3>Request Rejection Confirmation</h3><hr>",
                html: `
                Please provide a reason for rejecting the request.
                <br/><br/>
                <div style="display: flex; justify-content: space-around; align-items: center;">
                    <label for="reason" style="margin-right: 10px;"><strong>Reason:</strong>&nbsp;<span style="color: red;">*</span></label>
                    <textarea id="reason" rows="4" style="width: 70%;"></textarea>
                </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Submit",
                confirmButtonColor: "#00c0ef",
                cancelButtonText: "Close",
                cancelButtonColor: "#F8943F",
                preConfirm: () => {
                    const reason = document.getElementById('reason').value;
                    if (!reason) {
                        Swal.showValidationMessage('Please enter a reason');
                    }
                    return { reason: reason };
                }
            }).then((result) => {
                // if (result.isConfirmed) {
                    if (result.value) {
                    this.loader = true;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        requestid: value,
                        reason: result.value.reason,  // Use result.value.reason here
                        rejectedby: userInfo.userfirstname + " " + userInfo.userlastname,
                        sysusermasterid: userInfo.sysusermasterid
                    };

                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/rejectAdhocRequest`, obj).then(result => {
                        this.loader = false;
                        if (result.body.returnmsg === "Successful") {
                            this.$fire({
                                text: "Request Successfully Rejected!",
                                type: "success",
                                timer: 3000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            this.getPendingList(1);
                            this.allTabCount();
                        } else {
                            this.$fire({
                                text: result.body.returnvalue,
                                type: "error",
                                timer: 3000,
                            });
                        }
                    }).catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            });
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
  }
};
</script>


<style scoped>
.btn-danger {
    color: #fff !important;
    background-color: #f86c6b !important;
    border-color: #f86c6b !important;
}
.shrek-color, .shrek-color:hover ,.shrek-color:active, .shrek-color:not(:disabled):not(.disabled):active{
    color: #fff !important;
    background-color:  #B0C400 !important;
    border-color: #B0C400 !important;
}
.shrek-color:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem #B0C400(175, 181, 186, 0.5) !important;
}
.tab-content {
margin-top: 20px;
}

.nav-link {
    color: #6c757d;  /* Customize the text color */
    background-color: #f8f9fa; /* Customize the background */
    border-color: #dee2e6;    
}
.tabs .nav-tabs {
    display: flex;
    justify-content: center; /* Centers the tabs horizontally */
    align-items: center; /* Centers the content vertically */
}


.custom-outer-filter {
    padding-top: 25px;
    padding-left: 15px;
}


.cutom-view-all-btn {
border: none;
border-radius: 10px;
margin-left: 15px;
}

.cutom-view-all-btn:focus {
border: none !important;
border-radius: 10px !important;
margin-left: 15px !important;
outline: none;
}

.nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}


.nav-link {
        background: #7B7B7B !important;
        border-radius: 20px;
        border: none;
    }
    .nav-link.active {
        background: #F8943F !important;
    border-radius: 20px;
    border: none;
  }

  .nav-tabs {
    border-bottom: none !important;
}

.custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
}

.custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
}
.cutom-view-plan-btn {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 8px;
}
.cutom-view-plan-btn:focus {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 8px;
}

.cutom-btn-download {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 15px;
    background: #f09642 !important;
    border: 1px solid #f09642 !important;
} 
</style>